import { authHub, type authClass } from '@aplus-frontend/aplus-auth-sdk';
import { getEnv, getEnvMode } from '@/utils/env';
import { markRaw } from 'vue';
import { getPlatform } from './url';
let authClient: authClass;
export type Platform = 'aplus' | 'user' | 'admin' | 'quick' | 'word';
let platform: Platform;

export const initAuthCenter = async () => {
  const env = getEnv();
  platform = getPlatform();

  authClient = markRaw(
    authHub({
      platform,
      used: 'login', //指明用途
      env: getEnvMode(),
      debug: true,
      apiUrl: env.VITE_GLOB_API_URL,
      urlPrefix: env.VITE_GLOB_API_URL_PREFIX,
      defaultRedirectUrl: env.VITE_GLOB_APLUS_REDIRECT_URL
    })
  );
  //用途是login，init什么都不返回
  await authClient.init();
};

export const setAuthToken = async (
  token: string,
  record: Record<string, any>
) => {
  if (!authClient) {
    await initAuthCenter();
  }
  await authClient.setAuthToken(token, { ...record });
};

export const getOriginUrlParam = async (key: string) => {
  return await authClient.getUrlParam(key);
};

export default initAuthCenter();
// export default authClient;
